import { ExperimentItem } from '../ExperimentItem'
import style from './style.module.scss'

interface Props {
  items: any[]
}
export const ExperimentList = ({ items }: Props) => {
  return (
    <ul className={style.experiment_list}>
      {items.length > 0 && (
        <>
          <li className={style.titles}>
            <span>Name</span>
            <span>Status</span>
            <span>Start Date</span>
            <span>End Date</span>
            <span>Goals</span>
            <span>Current Goals</span>
            <span></span>
          </li>
          {items.map((item) => (
            <ExperimentItem item={item} />
          ))}
        </>
      )}
      {items.length === 0 && <div className={style.no_experiments}>No experiment</div>}
    </ul>
  )
}
